import React, { useEffect, useState, useRef } from "react";
import { Image } from "react-native";
import { Svg } from "../../assets/svg";
import { TouchableOpacity } from "react-native";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import VText from "components/VText";
import { Colors } from "colors";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { View } from "react-native";
import CropperImage from "./cropperImage";
import { useDispatch } from "react-redux";
import { imageUpload } from "appRedux/reducers/chatSlice";

const DragAndDropFile = ({ onFilesSelected, width, height }) => {
  const [files, setFiles] = useState([]);

  const dispatch = useDispatch();
  const _cropperRef = useRef();
  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    if (selectedFiles && selectedFiles.length > 0) {
      const newFiles = Array.from(selectedFiles);
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const handleUpload = (base64Data) => {
    const data = {
      base64Data: base64Data,
    };
    dispatch(imageUpload(data)).then((res) => {
      if (res.payload.status === 200) {
        onFilesSelected(res.payload.data.data.asset.Location);
      }
    });
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files;
    if (droppedFiles.length > 0) {
      const newFiles = Array.from(droppedFiles);
      setFiles(newFiles);
      _cropperRef?.current?.show();
    }
  };

  const handleRemoveFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (files.length > 0) {
      _cropperRef?.current?.show();
    }
  }, [files]);

  return (
    <section className="drag-drop" style={{ width: width, height: height }}>
      <div
        className={`document-uploader ${
          files.length > 0 ? "upload-box active" : "upload-box"
        }`}
        onDrop={handleDrop}
        onDragOver={(event) => event.preventDefault()}
      >
        <>
          {/* <Image accessibilityLabel="AI Icon" source={Svg.aiIcon} style={{ width: wp(22), height: hp(22) }} /> */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Image
              accessibilityLabel="Image Icon"
              source={Svg.imageIcon}
              style={{ width: wp(80), height: hp(80) }}
              resizeMode="contain"
            />
            <VText
              style={{
                fontSize: 16,
                fontWeight: "350",
                color: Colors.black,
                textAlign: "center",
                marginVertical: spV(10),
              }}
            >
              Drag an image here or{" "}
              <label
                htmlFor="browse"
                style={{ fontWeight: "400", textDecoration: "underline" }}
              >
                <TouchableOpacity>
                  <VText
                    style={{ fontWeight: "400", textDecoration: "underline" }}
                  >
                    upload a file
                  </VText>
                </TouchableOpacity>
              </label>
            </VText>
          </View>
          <input
            type="file"
            hidden
            id="browse"
            onChange={handleFileChange}
            accept=".png,.jpg,.jpeg,.webp"
          />
        </>

        {files.length > 0 && (
          <div className="file-list">
            <div className="file-list__container">
              {files.map((file, index) => (
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: spH(10),
                  }}
                  onPress={() => handleRemoveFile(index)}
                >
                  <p>{file.name}</p>
                  <Image
                    accessibilityLabel="Close Icon"
                    source={Svg.closeIcon}
                    style={{ width: wp(22), height: hp(22) }}
                  />
                </TouchableOpacity>
              ))}
            </div>
          </div>
        )}
      </div>
      <CropperImage
        ref={_cropperRef}
        files={files}
        handleUpload={handleUpload}
      />
    </section>
  );
};

export default DragAndDropFile;
